import { ShieldCheck, Truck, CalendarClock, BadgeCheck, CarFront } from "lucide-react";
import { Reveal } from "./motion";

const ITEMS = [
  { icon: ShieldCheck, title: "California Licensed", desc: "State-licensed & bonded vehicle verifier." },
  { icon: Truck, title: "Mobile Service", desc: "We come to your home, work or storage lot." },
  { icon: CalendarClock, title: "Same-Day Appointments", desc: "Fast scheduling, often same or next day." },
  { icon: BadgeCheck, title: "Professional & Reliable", desc: "Accurate REG 31, accepted the first time." },
  { icon: CarFront, title: "Hundreds Verified", desc: "Trusted by drivers, dealers & fleets." },
];

export default function Trust() {
  return (
    <section data-testid="trust-section" className="bg-mist py-16 lg:py-20">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 lg:gap-5">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <Reveal key={it.title} delay={i * 0.06}>
                <div data-testid={`trust-${i}`} className="card-soft h-full p-5 lg:p-6 flex flex-col items-start gap-3">
                  <span className="h-11 w-11 rounded-xl bg-brand/10 flex items-center justify-center text-brand">
                    <Icon size={22} />
                  </span>
                  <div>
                    <h3 className="font-display font-semibold text-ink text-sm lg:text-base leading-tight">{it.title}</h3>
                    <p className="text-slate2 text-xs lg:text-sm mt-1 leading-snug">{it.desc}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
